import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import CardMedia from '@mui/material/CardMedia';
import Fade from '@mui/material/Fade';
import PropTypes from 'prop-types';
import { buildCdnUrl } from '../../helpers';

function StaffInfoCard({ person, onClick }) {
  const [started, setStarted] = useState(false);
  const imageUrl = buildCdnUrl(`images/team_pictures/${person.picture?.name}`, {
    width: 280,
    format: 'webp',
    quality: 80,
  });

  return (
    <Fade
      in={started}
      timeout={300}
    >
      <Card
        onClick={onClick}
        sx={{
          textAlign: 'center',
          width: '100%',
          height: '100%',
          maxWidth: { xs: '6rem', s: '8.75rem' },
          maxHeight: { xs: '6rem', s: '8.75rem' },
          backgroundColor: 'rgba(255,255,255,0.1)',
          borderRadius: '1.375rem',
          position: 'relative',
          margin: '0 auto',
          '&:hover': {
            cursor: 'pointer',
            '& .image-overlay': {
              visibility: 'visible',
            },
            '& img': {
              transform: 'scale(1.05)',
            },
          },
        }}
      >
        <CardMedia
          component="img"
          onLoad={() => setStarted(true)}
          image={imageUrl}
          alt={`${person.user?.firstName} ${person.user?.lastName}`}
          loading="lazy"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          }}
        />
        <Box
          className="image-overlay"
          sx={{
            display: 'flex',
            flexDirection: 'column',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.4)',
            alignItems: 'center',
            visibility: 'hidden',
            justifyContent: 'center',
            borderRadius: '1.375rem',
          }}
        >
          <Typography
            variant="small_2"
            color="white"
            fontWeight={600}
            textAlign="center"
            sx={{ padding: '0.2rem' }}
          >
            {person.user?.firstName} {person.user?.lastName}
          </Typography>
          <Typography
            variant="xsmall_3"
            fontSize="0.75rem"
            color="white"
            textAlign="center"
            sx={{ padding: '0.2rem' }}
          >
            {person.position}
          </Typography>
        </Box>
      </Card>
    </Fade>
  );
}

StaffInfoCard.propTypes = {
  person: PropTypes.shape({
    user: PropTypes.shape({
      firstName: PropTypes.string.isRequired,
      lastName: PropTypes.string.isRequired,
    }).isRequired,
    position: PropTypes.string.isRequired,
    picture: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  onClick: PropTypes.func.isRequired,
};

export default StaffInfoCard;
